<div class="logo d-flex align-items-center">
  <a class="simple-text logo-mini">
    <div class="logo-img">
      <img
        *ngIf="currentBrand?.logo; else fallbackCover"
        [src]="currentBrand?.logo"
        class="img"
      />
      <ng-template #fallbackCover>
        <img src="../../assets/img/lounge-logo-sq.png" alt="img" width="80px" />
      </ng-template>
    </div>
  </a>
  <a href="javascript:void(0)" class="simple-text logo-normal">P!NK LOUNGE</a>
</div>

<div class="sidebar-wrapper" [class.pt-3]="isScanView">
  <div *ngIf="!isScanView; else scanView">
    <!-- Profil utilizator -->
    <div class="user" [appRestrictPermissions]="PermissionsEnum.SELF_PROFILE_UPDATE">
      <div class="photo">
        <img
          *ngIf="currentUser?.profile_pic; else fallbackLogo"
          [src]="currentUser?.profile_pic"
          class="img"
        />
        <ng-template #fallbackLogo>
          <img src="../../assets/img/default-avatar.png" alt="img" width="80px" />
        </ng-template>
      </div>

      <div class="user-info">
        <a class="collapsed">
          <span class="d-inline">
            {{ currentUser?.first_name }} {{ currentUser?.last_name }}
          </span>
          <span
            class="material-icons edit-user-profile-icon"
            (click)="editUser(currentUser)"
            >edit</span
          >
        </a>
      </div>
    </div>

    <!-- Meniul principal -->
    <ul class="nav">
      <li
        *ngFor="let menuitem of menuItems"
        routerLinkActive="active"
        class="nav-item"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="toggleActive($event)"
      >
        <!-- Single link -->
        <a
          *ngIf="menuitem.type === 'link'"
          [routerLink]="[menuitem.path]"
          [queryParams]="menuitem.queryParams"
          class="nav-link"
        >
          <i class="material-icons">{{ menuitem.icontype }}</i>
          <p>{{ menuitem.title | translate }}</p>
        </a>

        <!-- Submenu -->
        <a
          *ngIf="menuitem.type === 'sub'"
          data-toggle="collapse"
          [attr.href]="'#' + menuitem.collapse"
          (click)="updatePS()"
          class="nav-link"
        >
          <i class="material-icons">{{ menuitem.icontype }}</i>
          <p>{{ menuitem.title | translate }}<b class="caret"></b></p>
        </a>

        <div
          *ngIf="menuitem.type === 'sub'"
          [id]="menuitem.collapse"
          class="collapse primary-border"
        >
          <ul class="nav">
            <li
              *ngFor="let childitem of menuitem.children"
              routerLinkActive="active"
              class="nav-item"
              [appRestrictPermissions]="childitem.permission"
            >
              <a
                [routerLink]="[menuitem.path, childitem.path]"
                class="nav-link child-link"
              >
                <span class="sidebar-mini ml-2">
                  <i class="material-icons mr-3">{{ childitem.ab }}</i>
                </span>
                <span class="sidebar-normal">{{ childitem.title | translate }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <!-- Logout mobile -->
      <li class="nav-item" *ngIf="isMobileMenu()">
        <a class="nav-link" (click)="logout()">
          <i class="material-icons mr-3">power_settings_new</i>
          <p>{{ 'Logout' | translate }}</p>
        </a>
      </li>
    </ul>

    <!-- Dropdown menu mobile -->
    <div *ngIf="isMobileMenu()" class="mt-4">
      <ul class="nav navbar-nav nav-mobile-menu">
        <!-- Language selector dropdown mobile -->
        <li class="nav-item dropdown">
          <a
            class="nav-link"
            href="javascript:void(0)"
            id="language-sidebar-dropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="material-icons">language</i>
            <p>
              <span class="d-lg-none d-md-block">{{ 'Language' | translate }}</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="language-sidebar-dropdown">
            <a
              class="dropdown-item"
              href="javascript:void(0)"
              *ngFor="let language of translateService.getLangs()"
              (click)="langService.setLang(language)"
            >
              {{ language | uppercase }}
            </a>
          </div>
        </li>

        <!-- Menu dropdown mobile -->
        <li class="nav-item dropdown">
          <a
            class="nav-link"
            href="javascript:void(0)"
            id="brand-sidebar-dropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="material-icons">menu</i>
            <p>
              <span class="d-lg-none d-md-block">{{
                'NavbarMenu' | translate
              }}</span>
            </p>
          </a>

          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="brand-sidebar-dropdown"
          >
            <div class="dropdown-menu-section">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/brand-profile']"
                [appRestrictPermissions]="PermissionsEnum.BRAND_PROFILE_READ"
                ><i class="material-icons mr-3">business</i>
                {{ 'BrandData' | translate }}</a
              >
            </div>

            <div class="dropdown-menu-section custom-border">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/products']"
                [appRestrictPermissions]="PermissionsEnum.PRODUCTS_READ"
                ><i class="material-icons mr-3">menu_book</i>
                {{ 'Products' | translate }}</a
              >

              <a
                class="dropdown-item"
                [routerLink]="['/admin/assets']"
                [appRestrictPermissions]="PermissionsEnum.ASSETS_READ"
                ><i class="material-icons mr-3">qr_code</i>
                {{ 'Assets' | translate }}</a
              >

              <a
                class="dropdown-item"
                [routerLink]="['/admin/allergens']"
                [appRestrictPermissions]="PermissionsEnum.ALLERGENS_READ"
                ><i class="material-icons mr-3">disabled_visible</i>
                {{ 'Allergens' | translate }}</a
              >

              <a
                class="dropdown-item"
                [routerLink]="['/admin/categories']"
                [appRestrictPermissions]="PermissionsEnum.CATEGORIES_READ"
                ><i class="material-icons mr-3">category</i>
                {{ 'Categories' | translate }}</a
              >

              <a
                class="dropdown-item"
                [routerLink]="['/admin/types']"
                [appRestrictPermissions]="PermissionsEnum.TYPES_READ"
                ><i class="material-icons mr-3">view_compact_alt</i>
                {{ 'Types' | translate }}</a
              >

              <a
                class="dropdown-item"
                [routerLink]="['/admin/measurement-units']"
                [appRestrictPermissions]="PermissionsEnum.MEASUREMENT_UNITS_READ"
                ><i class="material-icons mr-3">scale</i>
                {{ 'MeasurementUnits' | translate }}</a
              >
            </div>

            <div class="dropdown-menu-section">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/settings']"
                [appRestrictPermissions]="PermissionsEnum.SETTINGS_READ"
                ><i class="material-icons mr-3">settings</i>
                {{ 'Settings' | translate }}</a
              >
              <a
                class="dropdown-item"
                [routerLink]="['/admin/accounts']"
                [appRestrictPermissions]="PermissionsEnum.USERS_READ"
                ><i class="material-icons mr-3">group</i>
                {{ 'Accounts' | translate }}</a
              >
              <a
                class="dropdown-item"
                [routerLink]="['/admin/roles']"
                [appRestrictPermissions]="PermissionsEnum.VIEW_ROLES_LIST"
                ><i class="material-icons mr-3">task</i>
                {{ 'Roles' | translate }}</a
              >
              <a
                class="dropdown-item"
                [routerLink]="['/admin/brand-invoice-profile']"
                [appRestrictPermissions]="PermissionsEnum.BRAND_INVOICE_PROFILE_READ"
                ><i class="material-icons mr-3">note</i>
                {{ 'BrandInvoiceProfile' | translate }}</a
              >
            </div>

            <a class="dropdown-item" (click)="logout()">
              <i class="material-icons mr-3">power_settings_new</i>
              {{ 'Logout' | translate }}
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- Scan view -->
<ng-template #scanView>
  <ul class="nav d-flex flex-column mt-0">
    <li
      *ngFor="let menuitem of scanMenuItems"
      #parentMenuItem
      class="nav-item"
      routerLinkActive="active"
    >
      <a
        *ngIf="menuitem.type === 'sub'"
        data-toggle="collapse"
        [attr.href]="'#' + menuitem.collapse"
        (click)="updatePS()"
        class="nav-link"
      >
        <i class="material-icons">{{ menuitem.icontype }}</i>
        <p>{{ menuitem.title | translate }}<b class="caret"></b></p>
      </a>

      <div
        *ngIf="menuitem.type === 'sub'"
        [id]="menuitem.collapse"
        class="collapse pl-2 ml-4"
      >
        <ul class="nav mt-0">
          <li *ngFor="let childitem of menuitem.children" class="nav-item">
            <a
              class="nav-link child-link p-0 mt-0"
              (click)="langService.setLang(childitem.value)"
            >
              <span
                class="sidebar-normal pl-3 py-2"
                [class.submenu-active]="childitem?.value === lang"
                >{{ childitem.title | translate }}</span
              >
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</ng-template>
